import React, {useState, useEffect} from 'react';
import { ListItemButton, ListItemIcon, Grid, ListItemText } from '@mui/material';
import moment from 'moment';
import 'moment/locale/es';

import { FaMapMarkerAlt, FaCalendarAlt, FaMedal } from 'react-icons/fa';

import { useTheme } from '@mui/material/styles';
import { supabase } from '../../supabaseClient'
import { useAuth } from '../../contexts/auth'
import { useCode } from '../../contexts/Code';

import { IconContext } from 'react-icons';
import * as IconsFa from 'react-icons/fa';
import * as IconsHi from 'react-icons/hi';
import { useCompany } from '../../contexts/Company';


const CustomIcon = ({ name }) => {
  const FaIcon = IconsFa[name];
  const HiIcon = IconsHi[name];

  if (FaIcon) {
    return <FaIcon />;
  } else if (HiIcon) {
    return <HiIcon />;
  } else {
    return <img src={name} alt="Icon" />;
  }
};

const Row = ({ icon, text }) => {
  return (
    <Grid item container alignItems="center" justifyContent="flex-end">
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText sx={{color: 'white'}} primary={text} />
      </div>
    </Grid>
  );
};
  const formatDateRange = (dateFrom, dateTo, company) => {
    const momentDateFrom = moment(dateFrom);
    const momentDateTo = moment(dateTo);

    const sameDay = momentDateFrom.isSame(momentDateTo, 'day');
    const sameMonth = momentDateFrom.month() === momentDateTo.month();
    const sameYear = momentDateFrom.year() === momentDateTo.year();
    console.log(company)
    const language = company.id === 45 ? 'en' : 'es';

    if (!dateTo || sameDay) {
      return language == 'en'
        ? momentDateFrom.format('MMMM D')
        : momentDateFrom.format('D [de] MMMM');
    } else if (sameMonth && sameYear) {
      return language == 'en'
        ? `${momentDateFrom.format('MMMM D')} - ${momentDateTo.format('D')}`
        : `${momentDateFrom.format('D')} y ${momentDateTo.format('D [de] MMMM')}`;
    } else {
      return language == 'en'
        ? `${momentDateFrom.format('MMMM D')} - ${momentDateTo.format('MMMM D')}`
        : `${momentDateFrom.format('D [de] MMMM')} y ${momentDateTo.format('D [de] MMMM')}`;
    }
  };

const getRandomMedalIcon = () => {
  const medals = [FaMedal, FaMedal, FaMedal]; // Agrega los íconos de oro, plata y bronce respectivamente
  const randomIndex = Math.floor(Math.random() * medals.length);
  return medals[randomIndex];
};

const SessionItem = ({ session, onClick, selected = false, isDemo = false }) => {
  const theme = useTheme();
  const user = useAuth();
  const {code} = useCode()
  const company = useCompany()

  moment.locale(company?.id === 45 ? 'en' : 'es'); // Establece el idioma al español o inglés según el ID de la compañía

  const currentDate = moment();
  const dateFrom = moment(session.date_from);

  const isBeforeDateFrom = isDemo || company?.demo ? false : currentDate.isBefore(dateFrom);

  const yt = localStorage.getItem(code+session.id+'yt') == 'true'
  const qz = localStorage.getItem(code+session.id+'qz') == 'true'
  const at = localStorage.getItem(code+session.id+'at') == 'true' || localStorage.getItem(code+session.id+'go')
  
  const score = yt + qz + at
  const medalColor = score > 2 ? 'gold' : score === 2 ? '#BEBEBE' : score === 1 ? '#CD7F32' : null;

  if (!company){
      return <></>
  }

  return (
    <ListItemButton
      selected={selected}
      onClick={(e) => onClick()}
      disabled={isBeforeDateFrom}
      key={session.name}
    >
      <ListItemIcon style={{ fontSize: '32px' }}>
        <IconContext.Provider value={{ color: theme.palette.primary.main, className: 'global-class-name' }}>
          <CustomIcon name={session.icon} />
        </IconContext.Provider>
      </ListItemIcon>
      <ListItemText sx={{color: 'white!important'}} primary={session.name} secondary={session.subtitle} />
      {(score > 0 && !isDemo) && (
        <ListItemIcon style={{ fontSize: '32px', marginLeft: '80px' }}>
          <IconContext.Provider value={{ color: medalColor, className: 'global-class-name' }}>
            <FaMedal />
          </IconContext.Provider>
        </ListItemIcon>
      )}
      <Grid container direction="column">
        <Row
          icon={<FaCalendarAlt style={{ marginLeft: '30px'}} />}
          text={formatDateRange(session.date_from, session.date_to, company)}
        />
        <Row
          icon={<FaMapMarkerAlt style={{ marginLeft: '30px' }} />}
          text={session.location}
        />
       
      </Grid>
      
    </ListItemButton>
  );
};

export default SessionItem;
